import { Label, LineItem, Value, XIcon } from "../../common";
import { Maybe } from "@src/shared/node/GeneratedDatabaseTypes";
import { Pill } from "../../../..";
import React from "react";
export type QuantityLineProps = {
  getCurrencyDisplay: (n: number) => string;
  isTotal?: boolean;
  label?: Maybe<string>;
  overrideTotal?: number;
  quantity: number;
  unitPrice: number;
};
export function QuantityLine({
  getCurrencyDisplay,
  label,
  isTotal,
  quantity,
  overrideTotal,
  unitPrice
}: QuantityLineProps) {
  const total = overrideTotal ?? quantity * unitPrice;
  return <LineItem data-sentry-element="LineItem" data-sentry-component="QuantityLine" data-sentry-source-file="QuantityLine.tsx">
      <Label data-sentry-element="Label" data-sentry-source-file="QuantityLine.tsx">
        <span>{quantity}</span>
        <XIcon data-sentry-element="XIcon" data-sentry-source-file="QuantityLine.tsx" />
        {label ? <span>{label}</span> : null}
        <span>{getCurrencyDisplay(unitPrice)}</span>
      </Label>
      {isTotal ? <Pill small>{getCurrencyDisplay(total)}</Pill> : <Value>{getCurrencyDisplay(total)}</Value>}
    </LineItem>;
}